export default __webpack_public_path__ + "static/media/task-manager.899c5e6d.webp";